var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callout warning mt-2 p-2 text-sm"},[_c('div',{staticClass:"flex items-start gap-2"},[_c('fluent-icon',{staticClass:"mt-0.5 flex-shrink-0",attrs:{"icon":"warning","size":16}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"font-semibold"},[_vm._v("\n        "+_vm._s(_vm.$t(
            'CHATLYN_CONTACT_LISTS.SEND_MESSAGE_MODAL.TOTAL_COUNT_WARNING.TITLE'
          ))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"text-xs opacity-75"},[_vm._v("\n        "+_vm._s(_vm.$t(
            'CHATLYN_CONTACT_LISTS.SEND_MESSAGE_MODAL.TOTAL_COUNT_WARNING.MESSAGE'
          ))+"\n      ")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }